var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeyondMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 60,
    height: 60,
    rx: 11,
    transform: "translate(1211 702)",
    fill: "#5d44ff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 136,
    height: 131,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 60.001,
    height: 60,
    rx: 8.758,
    transform: "translate(38.698 34.62)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 65.839,
    height: 63.778,
    transform: "translate(35.857 31.645)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 65.839,
    height: 61.111,
    transform: "translate(35.857 34.313)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 13.949,
    height: 8.223,
    transform: "translate(36.201 57.181)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 16.326,
    height: 16.355,
    transform: "translate(37.055 36.757)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 1.432,
    height: 1.434,
    transform: "translate(37.259 54.606)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 16.322,
    height: 16.351,
    transform: "translate(75.969 77.897)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 1.431,
    height: 1.434,
    transform: "translate(96.059 85.652)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 10.795,
    height: 10.814,
    transform: "translate(79.02 31.645)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 0.915,
    height: 0.917,
    transform: "translate(91.537 36.593)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M43.379,66.817V88.164a1.212,1.212,0,0,0,1.212,1.212H71.41a1.212,1.212,0,0,0,1.212-1.212V66.817Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M65.969,58.654V80.765a1.212,1.212,0,0,0,1.212,1.211H94a1.212,1.212,0,0,0,1.212-1.211V58.654Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(-1184 -685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 60,
    height: 60,
    rx: 7,
    transform: "translate(1184 685)",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(-29 -17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 60,
    height: 60,
    rx: 11,
    transform: "translate(1211 702)",
    fill: "#5d44ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(1172 667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M45.777,85.312a13.26,13.26,0,0,1-1.38-.583",
    fill: "none",
    stroke: "#222221",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M41.837,83.109a14.264,14.264,0,0,1-1.042-21.615c1.847-1.752,4.139-2.989,5.921-4.807,2.312-2.359,3.6-5.513,5.35-8.317C55.859,42.3,60.978,37.221,67.9,35.5s15.573-.07,21.742,3.52c3.1,1.8,6,4.466,6.733,7.983.8,3.837-1.119,7.877-.237,11.7.623,2.7,2.551,4.875,3.729,7.378,2.988,6.35.651,14.307-4.225,19.348s-11.792,7.586-18.67,8.87a24.526,24.526,0,0,1-9.129.329c-6.229-1.207-11.469-6.271-17.5-7.45",
    fill: "none",
    stroke: "#222221",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3.034 3.034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M48.835,86.965a12.054,12.054,0,0,0-1.5-.026",
    fill: "none",
    stroke: "#222221",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 136,
    height: 131,
    xlinkHref: "data:image/png;base64,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"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M91.008,48.3a2.521,2.521,0,0,0-.36.026,2.586,2.586,0,1,0-5.03-1.2,1.8,1.8,0,0,0-2.608,1.352,2.519,2.519,0,1,0-.921,4.864h8.919a2.52,2.52,0,0,0,0-5.039",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M85.043,88.607a1.547,1.547,0,0,0-.216.016,1.522,1.522,0,0,0,.045-.372,1.547,1.547,0,0,0-3.055-.348,1.068,1.068,0,0,0-.494-.121,1.079,1.079,0,0,0-1.068.93,1.488,1.488,0,0,0-.551-.1,1.508,1.508,0,0,0,0,3.016h5.339a1.508,1.508,0,0,0,0-3.016",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M47.635,60.365a2.522,2.522,0,0,0-.36.026,2.586,2.586,0,1,0-5.03-1.2,1.8,1.8,0,0,0-2.608,1.352,2.519,2.519,0,1,0-.921,4.864h8.919a2.52,2.52,0,0,0,0-5.039",
    fill: "#ccc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M47.166,52.358a7.674,7.674,0,1,1,5.461-9.375A7.66,7.66,0,0,1,47.166,52.358Z",
    fill: "none",
    stroke: "#222221",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3 3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M38.157,56.017a.717.717,0,1,1,.51-.876.715.715,0,0,1-.51.876",
    fill: "#ccc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M89.224,80.339a7.669,7.669,0,1,1-10.816.63A7.685,7.685,0,0,1,89.224,80.339Z",
    fill: "none",
    stroke: "#222221",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3 3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M97.251,85.833a.716.716,0,1,1-1.01.059.719.719,0,0,1,1.01-.059",
    fill: "#ccc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M85.662,41.8a4.905,4.905,0,1,1,3.49-5.992A4.9,4.9,0,0,1,85.662,41.8Z",
    fill: "none",
    stroke: "#222221",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "3 3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M92.111,37.495a.458.458,0,1,1,.326-.56.458.458,0,0,1-.326.56",
    fill: "#ccc"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M72.622,68.15a1.212,1.212,0,0,0-1.212-1.212H44.591a1.212,1.212,0,0,0-1.212,1.212v1.164H72.622Z",
    fill: "#faf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M43.379,69.314v18.85a1.212,1.212,0,0,0,1.212,1.212H71.41a1.212,1.212,0,0,0,1.212-1.212V69.314Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M71.41,89.438H44.591a1.276,1.276,0,0,1-1.274-1.274V69.314a.062.062,0,0,1,.062-.062H72.622a.062.062,0,0,1,.062.062v18.85a1.276,1.276,0,0,1-1.274,1.274M43.441,69.376V88.164a1.151,1.151,0,0,0,1.15,1.15H71.41a1.151,1.151,0,0,0,1.15-1.15V69.376Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M45.89,68.234a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#faf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M47.774,68.234a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#faf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M49.657,68.234a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#faf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M72.622,68.15a1.212,1.212,0,0,0-1.212-1.212H44.591a1.212,1.212,0,0,0-1.212,1.212v1.164H72.622Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M72.622,69.376H43.379a.062.062,0,0,1-.062-.062V68.15a1.275,1.275,0,0,1,1.274-1.274H71.41a1.275,1.275,0,0,1,1.274,1.274v1.164a.062.062,0,0,1-.062.062m-29.181-.124H72.56v-1.1A1.151,1.151,0,0,0,71.41,67H44.591a1.151,1.151,0,0,0-1.15,1.15Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M43.379,69.314v18.85a1.212,1.212,0,0,0,1.212,1.212H71.41a1.212,1.212,0,0,0,1.212-1.212V69.314Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M71.41,89.438H44.591a1.276,1.276,0,0,1-1.274-1.274V69.314a.062.062,0,0,1,.062-.062H72.622a.062.062,0,0,1,.062.062v18.85a1.276,1.276,0,0,1-1.274,1.274M43.441,69.376V88.164a1.151,1.151,0,0,0,1.15,1.15H71.41a1.151,1.151,0,0,0,1.15-1.15V69.376Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M45.89,68.234a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M47.774,68.234a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M49.657,68.234a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M63.67,83.3l-2.452.857s-.016.8.012,1.836a7.513,7.513,0,0,0,2.463-.468Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M61.231,86.06A.065.065,0,0,1,61.165,86c-.028-1.031-.013-1.831-.012-1.839A.065.065,0,0,1,61.2,84.1l2.452-.857a.065.065,0,0,1,.059.008.063.063,0,0,1,.028.053l.023,2.225a.067.067,0,0,1-.042.062,7.537,7.537,0,0,1-2.484.472Zm.052-1.854c0,.179-.01.864.012,1.721a7.381,7.381,0,0,0,2.332-.446l-.021-2.087Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M60.949,86.931l.266.558,3.628.222c.824-.614,1.47-1.152,1.47-1.152Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M64.843,87.777h0l-3.629-.221a.067.067,0,0,1-.055-.038l-.266-.558a.067.067,0,0,1,.055-.094l5.364-.371a.066.066,0,0,1,.065.041.064.064,0,0,1-.019.074c-.006.006-.656.546-1.472,1.155a.068.068,0,0,1-.039.013m-3.586-.351,3.566.218c.567-.423,1.05-.811,1.289-1l-5.063.351Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M61.263,87.59l.86,1.808a13.4,13.4,0,0,0,2.719-1.687l-3.627-.222Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M62.124,89.46a.061.061,0,0,1-.056-.035l-.909-1.909a.061.061,0,0,1,.06-.088l3.628.222a.061.061,0,0,1,.033.111,13.55,13.55,0,0,1-2.735,1.695.052.052,0,0,1-.021,0m-.808-1.9,0,.006.836,1.756a13.311,13.311,0,0,0,2.515-1.557Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M52.72,87.248s1.351,5.107,1.613,5.46,6.554.614,8.737-.358a17.989,17.989,0,0,0-1.053-5.183s.023-.366-.021-1.55c0,0,2.313-.731,2.992-1.935,0,0-2.344-3.612-3.435-3.725a7.52,7.52,0,0,0-2.5.333L54.3,81.35",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M57.682,93.1a9.386,9.386,0,0,1-3.4-.352c-.267-.358-1.568-5.272-1.623-5.481a.062.062,0,0,1,.044-.076.061.061,0,0,1,.075.044c.375,1.418,1.394,5.157,1.6,5.439.251.325,6.447.574,8.624-.36a17.878,17.878,0,0,0-1.047-5.119.092.092,0,0,1-.005-.028s.023-.38-.02-1.545a.062.062,0,0,1,.043-.061c.023-.008,2.256-.724,2.938-1.874-.235-.356-2.373-3.562-3.369-3.665a7.536,7.536,0,0,0-2.476.33l-4.754,1.062a.062.062,0,0,1-.074-.047.063.063,0,0,1,.047-.074l4.749-1.06a7.463,7.463,0,0,1,2.521-.334c1.107.114,3.384,3.6,3.48,3.752a.059.059,0,0,1,0,.064C64.4,84.845,62.4,85.55,62.06,85.661c.037,1.025.023,1.417.019,1.5a18.241,18.241,0,0,1,1.053,5.191.062.062,0,0,1-.037.059,16.322,16.322,0,0,1-5.413.69",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M54.987,81.575a4.579,4.579,0,0,0,2.143,0,3.084,3.084,0,0,0,1.685-.935A7.4,7.4,0,0,0,56.729,81c-.815.25-1.4.453-1.742.579",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M56.066,81.77a4.619,4.619,0,0,1-1.094-.131.064.064,0,0,1-.05-.06.066.066,0,0,1,.043-.065c.348-.127.934-.331,1.745-.58a7.528,7.528,0,0,1,2.1-.356.066.066,0,0,1,.06.038.064.064,0,0,1-.01.07,3.154,3.154,0,0,1-1.719.957,4.665,4.665,0,0,1-1.08.127m-.841-.21a4.518,4.518,0,0,0,1.89-.045,3.148,3.148,0,0,0,1.547-.8,7.555,7.555,0,0,0-1.914.346c-.66.2-1.169.375-1.523.5",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M54.406,81.384a3.252,3.252,0,0,0,.581.192c.344-.126.927-.329,1.742-.579a7.359,7.359,0,0,1,2.086-.353,1.5,1.5,0,0,0,.237-.354,20.374,20.374,0,0,0-4.646,1.094",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M54.987,81.641l-.015,0a3.228,3.228,0,0,1-.594-.2.063.063,0,0,1-.037-.062.065.065,0,0,1,.042-.058,20.641,20.641,0,0,1,4.663-1.1.065.065,0,0,1,.066.09,1.5,1.5,0,0,1-.247.372.069.069,0,0,1-.049.023,7.344,7.344,0,0,0-2.068.35c-.808.248-1.391.451-1.738.578a.093.093,0,0,1-.023,0m-.4-.254a3.9,3.9,0,0,0,.393.119c.351-.127.93-.328,1.726-.573a7.536,7.536,0,0,1,2.075-.355,1.719,1.719,0,0,0,.153-.213,20.326,20.326,0,0,0-4.347,1.022",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M58.168,80.788l-.053-.5-.029-.274a9.21,9.21,0,0,1-2.547.816l.133.653",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M55.673,81.548a.064.064,0,0,1-.064-.052l-.134-.654a.065.065,0,0,1,.01-.049.064.064,0,0,1,.042-.028,9.089,9.089,0,0,0,2.527-.808.062.062,0,0,1,.063,0,.065.065,0,0,1,.035.051l.082.775a.065.065,0,0,1-.058.072.067.067,0,0,1-.072-.059l-.072-.674a9.439,9.439,0,0,1-2.415.761l.12.588a.065.065,0,0,1-.051.078h-.013",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M57.99,79.1l-2.681.609.169.823.061.3a9.226,9.226,0,0,0,2.548-.816Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M55.539,80.895a.065.065,0,0,1-.064-.053l-.23-1.124a.065.065,0,0,1,.049-.077l2.681-.608a.066.066,0,0,1,.053.011.067.067,0,0,1,.027.046l.1.916a.068.068,0,0,1-.032.064,9.163,9.163,0,0,1-2.569.824h-.012m-.153-1.14.2,1a9.1,9.1,0,0,0,2.427-.775l-.085-.8Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    transform: "translate(51.856 79.419)",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M60.684,74.8h-.062a7.868,7.868,0,0,0-.354-2.513,3.9,3.9,0,0,0-.821-1.546,1.994,1.994,0,0,0-1.551-.681L57.891,70a2.061,2.061,0,0,1,1.6.7,3.951,3.951,0,0,1,.835,1.57,7.931,7.931,0,0,1,.357,2.532",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M58.073,69.712s2.415.605,2.6,4.481L50.637,78.1s-2.333-3.3-.545-5.387c-.466-1.907,2.28-3.47,4.438-3.853,1.333-.237,2.678-.309,3.543.856",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M59.026,76.159l-.445-1.842s1.907-1.26,2.513.433a1.258,1.258,0,0,1-2.068,1.409",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M60.021,76.645a1.454,1.454,0,0,1-1.039-.442.056.056,0,0,1-.016-.029l-.446-1.842a.061.061,0,0,1,.026-.066,2.479,2.479,0,0,1,1.815-.4,1.291,1.291,0,0,1,.792.86,1.351,1.351,0,0,1-.425,1.716,1.336,1.336,0,0,1-.707.2m-.939-.517a1.306,1.306,0,0,0,1.58.212,1.234,1.234,0,0,0,.374-1.569,1.172,1.172,0,0,0-.714-.784,2.319,2.319,0,0,0-1.671.36Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M59.643,76.082a.033.033,0,0,0,.013-.007.036.036,0,0,0,0-.051c-.007-.007-.624-.723-.163-1.282a.794.794,0,0,1,.551-.32,1,1,0,0,1,.651.23.036.036,0,0,0,.048-.054,1.054,1.054,0,0,0-.7-.248.868.868,0,0,0-.6.346c-.5.607.158,1.368.165,1.375a.035.035,0,0,0,.037.011",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M60.289,75.151a.036.036,0,0,0,.023-.022.035.035,0,0,0-.021-.046c-.007,0-.713-.25-1.012.309a.036.036,0,1,0,.063.034c.27-.505.918-.278.924-.276a.037.037,0,0,0,.023,0",
    fill: "#683936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M58.834,71.1a8.7,8.7,0,0,1,1.293,3.385A4.8,4.8,0,0,1,56.9,79.73c-2.358.867-4.681.6-6.351-2.226s-1.154-5.4,1.761-6.9c2.871-1.47,5.407-1.128,6.525.491",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M58.876,71.158a9.808,9.808,0,0,1,1.305,3.484,4.669,4.669,0,0,1-2.89,5.263c-2.191.821-4.379.484-6.023-2.44s-1.228-5.539,1.469-6.983c2.656-1.422,5.046-1.005,6.139.676",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M55.343,80.354c-1.675,0-3.058-.956-4.128-2.859a5.819,5.819,0,0,1-.817-4.432,4.4,4.4,0,0,1,2.311-2.636c2.558-1.37,5.057-1.089,6.219.7a9.982,9.982,0,0,1,1.314,3.507,4.738,4.738,0,0,1-2.929,5.333,5.662,5.662,0,0,1-1.97.391m.482-10.666a6.571,6.571,0,0,0-3.058.848,4.284,4.284,0,0,0-2.25,2.562,5.7,5.7,0,0,0,.806,4.336c1.43,2.543,3.431,3.355,5.947,2.413a4.616,4.616,0,0,0,2.851-5.194,9.848,9.848,0,0,0-1.295-3.46v0a3.426,3.426,0,0,0-3-1.5",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M58.214,72.129s.322,1.713,1.26,1.96l.984-.114s-.383-6.074-6.535-4.484-3.166,7.522-3.166,7.522a.4.4,0,0,0,.631-.19,6.467,6.467,0,0,0,.7-3.419S57.7,74.5,58.214,72.129",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M50.572,77.469l-.02-.059A2.4,2.4,0,0,0,52,75.477a6.6,6.6,0,0,0-.226-2.534l.061-.014a6.657,6.657,0,0,1,.226,2.559,2.458,2.458,0,0,1-1.493,1.981",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M51.052,78.195a4.584,4.584,0,0,1-1.828-3.324,2.459,2.459,0,0,1,.152-1.155,1.331,1.331,0,0,1,.84-.785l.016.06a1.268,1.268,0,0,0-.8.749,2.406,2.406,0,0,0-.147,1.127,4.519,4.519,0,0,0,1.8,3.278Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M52.064,76.453s-1.86-.1-1.428,1.643a1.258,1.258,0,0,0,2.5.028",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M51.845,79.3a1.632,1.632,0,0,1-1.092-2.433,1.745,1.745,0,0,1,1.315-.48.062.062,0,0,1,.059.065.06.06,0,0,1-.066.058,1.665,1.665,0,0,0-1.213.437,1.239,1.239,0,0,0-.151,1.13c.175.7.616,1.117,1.181,1.1a1.308,1.308,0,0,0,1.2-1.068.062.062,0,0,1,.072-.05.063.063,0,0,1,.05.073,1.415,1.415,0,0,1-1.32,1.169h-.036",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M52.582,78.4a.038.038,0,0,1-.015,0,.035.035,0,0,1-.031-.04c0-.01.119-.947-.574-1.158a.8.8,0,0,0-.637.039,1,1,0,0,0-.414.552.036.036,0,0,1-.044.026.037.037,0,0,1-.026-.044,1.052,1.052,0,0,1,.449-.6.871.871,0,0,1,.693-.045c.752.228.626,1.226.624,1.236a.036.036,0,0,1-.025.03",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M51.529,77.983a.036.036,0,0,1-.039-.056c0-.006.455-.6,1.014-.3a.036.036,0,0,1,.014.049.035.035,0,0,1-.048.015c-.505-.271-.918.276-.922.282a.041.041,0,0,1-.019.013",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M57.137,77.638a.57.57,0,0,1-.76-.116.036.036,0,0,1,.059-.042c.011.015.271.365.753.043a.036.036,0,1,1,.04.06c-.032.021-.062.039-.092.055",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M56.805,77.745a.552.552,0,0,1-.235-.052.6.6,0,0,1-.206-.163.05.05,0,0,1,.013-.071.048.048,0,0,1,.037-.009.05.05,0,0,1,.034.02c.011.015.262.354.732.04a.053.053,0,0,1,.072.014.052.052,0,0,1-.014.071,1.055,1.055,0,0,1-.094.056.712.712,0,0,1-.339.094m-.4-.265-.011,0a.019.019,0,0,0-.005.028.52.52,0,0,0,.193.153.586.586,0,0,0,.547-.041.991.991,0,0,0,.09-.055.02.02,0,0,0,.006-.028.022.022,0,0,0-.03,0c-.494.33-.762-.032-.773-.047a.019.019,0,0,0-.014-.009h0",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M53.15,75.706s-.435-.2.175-.8.89-.593,1.064-.438.072.452-.277.782c-.418.4-.723.576-.962.457",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M54.835,76.551a.371.371,0,1,1-.477-.319.41.41,0,0,1,.477.319",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M58.552,75.428a.371.371,0,1,1-.477-.319.41.41,0,0,1,.477.319",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M58.721,74.17s.251-.408-.589-.57-1.07,0-1.13.225c-.054.206.19.416.664.5.568.1.922.079,1.055-.152",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M56.974,76.833a.035.035,0,0,1-.037-.011.035.035,0,0,1,0-.051.977.977,0,0,0,.287-.5.614.614,0,0,0-.247-.592.254.254,0,0,0-.309.073l-.015.016c-.35.374-.574.322-.7.211a4.709,4.709,0,0,1-.464-1.529.037.037,0,0,1,.027-.043.036.036,0,0,1,.043.027A4.536,4.536,0,0,0,56,75.929c.15.13.352.061.6-.206l.018-.018a.323.323,0,0,1,.392-.086.681.681,0,0,1,.285.668,1.031,1.031,0,0,1-.311.539.033.033,0,0,1-.013.007",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M56.964,76.85a.052.052,0,0,1-.035-.09.953.953,0,0,0,.283-.488.6.6,0,0,0-.239-.575.241.241,0,0,0-.291.071l-.009.008-.006.007c-.358.383-.59.327-.723.212a3.772,3.772,0,0,1-.434-1.37c-.015-.073-.026-.131-.034-.167a.053.053,0,0,1,.038-.062.048.048,0,0,1,.039.007.05.05,0,0,1,.023.032c.026.114.051.231.076.348a3.042,3.042,0,0,0,.36,1.134c.142.124.337.055.58-.2l.018-.019a.338.338,0,0,1,.41-.088.7.7,0,0,1,.293.683,1.051,1.051,0,0,1-.316.549.057.057,0,0,1-.019.01l-.014,0m-.088-1.209a.24.24,0,0,1,.111.028.632.632,0,0,1,.255.608.994.994,0,0,1-.292.506.021.021,0,0,0,0,.029.019.019,0,0,0,.021.006l.008,0a1.021,1.021,0,0,0,.306-.53.667.667,0,0,0-.277-.651.311.311,0,0,0-.375.083l-.016.018c-.256.274-.466.344-.624.207a2.96,2.96,0,0,1-.369-1.152c-.025-.116-.05-.233-.076-.347a.02.02,0,0,0-.009-.013.016.016,0,0,0-.015,0,.021.021,0,0,0-.016.024c.008.036.02.1.034.168a3.792,3.792,0,0,0,.424,1.353c.175.151.411.079.681-.21l.005-.007.01-.01a.315.315,0,0,1,.216-.1",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M54.705,73.94a6.431,6.431,0,0,1-1.1-.1,12.793,12.793,0,0,1-1.8-.5l-1.442-.477.02-.059,1.442.477a12.879,12.879,0,0,0,1.788.5,6.273,6.273,0,0,0,1.7.064,4.4,4.4,0,0,0,2.187-.76,2.8,2.8,0,0,0,1.18-1.932l.061.006a2.862,2.862,0,0,1-1.2,1.976,4.455,4.455,0,0,1-2.217.772c-.206.02-.411.03-.617.03",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M55.18,93.383l-.014,0a.034.034,0,0,1-.016-.044,1.576,1.576,0,0,1,.334-.5.03.03,0,0,1,.022-.008c.015,0,1.526.014,3.068,0a.032.032,0,0,1,.033.032.033.033,0,0,1-.032.034c-1.466.016-2.9,0-3.056,0a1.616,1.616,0,0,0-.309.472.034.034,0,0,1-.03.019",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M57.745,89.191a.033.033,0,0,1-.032-.025.033.033,0,0,1,.024-.04A11.626,11.626,0,0,0,61,87.8a.033.033,0,0,1,.034.056,11.666,11.666,0,0,1-3.278,1.338h-.008",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M62,85.682h0a.067.067,0,0,1-.065-.067,27.086,27.086,0,0,0-.3-3.465.066.066,0,0,1,.13-.019,27.207,27.207,0,0,1,.3,3.487.066.066,0,0,1-.066.064",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M61.984,85.124a.033.033,0,0,1-.011-.064,8.2,8.2,0,0,0,2.747-1.73.032.032,0,0,1,.046,0,.033.033,0,0,1,0,.046,8.266,8.266,0,0,1-2.772,1.746l-.011,0",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M57.4,81.973a.032.032,0,0,1-.031-.023.033.033,0,0,1,.021-.041c1.879-.613,2.08-1.691,2.081-1.7a.033.033,0,1,1,.065.011c-.007.046-.205,1.127-2.126,1.753l-.01,0",
    fill: "#222221"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M74.133,43.731a1.166,1.166,0,0,0-1.171-1.162H47.06a1.166,1.166,0,0,0-1.17,1.162v1.116H74.133Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M45.89,44.847V62.921a1.167,1.167,0,0,0,1.171,1.163h25.9a1.167,1.167,0,0,0,1.17-1.163V44.847Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M74.133,44.909H45.89a.062.062,0,0,1-.062-.062V43.731a1.23,1.23,0,0,1,1.233-1.224h25.9a1.23,1.23,0,0,1,1.232,1.224v1.116a.062.062,0,0,1-.062.062m-28.181-.124H74.071V43.731a1.1,1.1,0,0,0-1.108-1.1h-25.9a1.105,1.105,0,0,0-1.109,1.1Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M72.963,64.146h-25.9a1.231,1.231,0,0,1-1.233-1.225V44.847a.062.062,0,0,1,.062-.062H74.133a.062.062,0,0,1,.062.062V62.921a1.23,1.23,0,0,1-1.232,1.225M45.952,44.909V62.921a1.106,1.106,0,0,0,1.109,1.1h25.9a1.106,1.106,0,0,0,1.108-1.1V44.909Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M48.316,43.812a.607.607,0,1,1-.606-.6.6.6,0,0,1,.606.6",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M50.135,43.812a.607.607,0,1,1-.606-.6.6.6,0,0,1,.606.6",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M51.954,43.812a.607.607,0,1,1-.606-.6.6.6,0,0,1,.606.6",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M95.212,60.75A1.212,1.212,0,0,0,94,59.538H67.181a1.212,1.212,0,0,0-1.212,1.212v1.164H95.212Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M95.212,61.976H65.969a.062.062,0,0,1-.062-.062V60.75a1.275,1.275,0,0,1,1.274-1.274H94a1.275,1.275,0,0,1,1.274,1.274v1.164a.062.062,0,0,1-.062.062m-29.181-.124H95.15v-1.1A1.151,1.151,0,0,0,94,59.6H67.181a1.151,1.151,0,0,0-1.15,1.15Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M94,82.038H67.181a1.275,1.275,0,0,1-1.274-1.274V61.914a.062.062,0,0,1,.062-.062H95.212a.062.062,0,0,1,.062.062v18.85A1.275,1.275,0,0,1,94,82.038M66.031,61.976V80.764a1.151,1.151,0,0,0,1.15,1.15H94a1.151,1.151,0,0,0,1.15-1.15V61.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M68.48,60.834a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M70.364,60.834a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M72.247,60.834a.628.628,0,1,1-.628-.628.628.628,0,0,1,.628.628",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M65.969,61.914v18.85a1.212,1.212,0,0,0,1.212,1.212H94a1.212,1.212,0,0,0,1.212-1.212V61.914Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M94,82.038H67.181a1.275,1.275,0,0,1-1.274-1.274V61.914a.062.062,0,0,1,.062-.062H95.212a.062.062,0,0,1,.062.062v18.85A1.275,1.275,0,0,1,94,82.038M66.031,61.976V80.764a1.151,1.151,0,0,0,1.15,1.15H94a1.151,1.151,0,0,0,1.15-1.15V61.976Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M59.8,54.085a8.663,8.663,0,0,1,3.033.612c.839.436,2.021,2.364,2.434,3.944a4.347,4.347,0,0,1-2.378.868,20.981,20.981,0,0,1-.256,3.462c-.256.983-6.663,1.239-8.072.086l.256-3.249a3.618,3.618,0,0,1-2.563-1.11s1.025-3.844,3.033-4.4a13.21,13.21,0,0,1,4.513-.214",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M58.6,63.881c-.19,0-.382,0-.574-.009a6.714,6.714,0,0,1-3.508-.768.063.063,0,0,1-.022-.053l.251-3.183a3.567,3.567,0,0,1-2.545-1.133.061.061,0,0,1-.011-.054,12.4,12.4,0,0,1,.768-2,4.2,4.2,0,0,1,2.308-2.44,13.4,13.4,0,0,1,4.535-.216,8.569,8.569,0,0,1,3.056.62c.848.44,2.046,2.376,2.466,3.983a.061.061,0,0,1-.021.063,4.457,4.457,0,0,1-2.355.88,19.887,19.887,0,0,1-.258,3.418c-.051.194-.3.364-.729.505a12.18,12.18,0,0,1-3.361.39m-3.978-.853c1.171.9,5.6.9,7.3.345.486-.158.62-.315.647-.418a21.053,21.053,0,0,0,.254-3.446.062.062,0,0,1,.06-.062,4.311,4.311,0,0,0,2.309-.831c-.421-1.571-1.576-3.441-2.392-3.864a8.643,8.643,0,0,0-3.005-.606h-.008a13.222,13.222,0,0,0-4.488.212c-1.858.514-2.88,3.969-2.981,4.326a3.608,3.608,0,0,0,2.495,1.062.059.059,0,0,1,.045.02.06.06,0,0,1,.017.046Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M65.268,58.641l-.152-.436a3.959,3.959,0,0,1-1.607.654l.141.529a4.5,4.5,0,0,0,1.618-.747",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M63.649,59.431a.044.044,0,0,1-.042-.032l-.141-.53a.043.043,0,0,1,.007-.036.046.046,0,0,1,.031-.019,3.93,3.93,0,0,0,1.588-.646.046.046,0,0,1,.038-.005.045.045,0,0,1,.027.027l.152.436a.045.045,0,0,1-.014.049,4.584,4.584,0,0,1-1.636.755h-.01m-.085-.536.117.44a4.489,4.489,0,0,0,1.535-.709l-.123-.353a4.077,4.077,0,0,1-1.529.622",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M61.943,54.414a16.872,16.872,0,0,0-4.81-.377,2.657,2.657,0,0,0,2.485,1.791,2.24,2.24,0,0,0,2.325-1.414",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M59.868,55.884q-.123,0-.255-.012a2.722,2.722,0,0,1-2.523-1.824.042.042,0,0,1,.007-.036.043.043,0,0,1,.031-.019,15.24,15.24,0,0,1,4.857.41.046.046,0,0,1,0,.026,2.308,2.308,0,0,1-2.116,1.455M57.19,54.075a2.332,2.332,0,0,0,.439.759,2.863,2.863,0,0,0,1.992.95,2.2,2.2,0,0,0,2.267-1.351,18.4,18.4,0,0,0-4.7-.358",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M61.481,54.554a23.118,23.118,0,0,0-3.673-.32s.148,1.112,1.815,1.238a1.8,1.8,0,0,0,1.858-.918",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M59.823,55.542c-.066,0-.134,0-.205-.008-1.7-.128-1.87-1.28-1.872-1.292a.061.061,0,0,1,.015-.048.058.058,0,0,1,.046-.022c.724-.013,1.834.085,2.276.128,1.425.139,1.444.2,1.457.235a.061.061,0,0,1,0,.044,1.844,1.844,0,0,1-1.715.963m-1.939-1.247c.063.24.372,1.012,1.744,1.116a1.753,1.753,0,0,0,1.766-.821,27.475,27.475,0,0,0-3.51-.3",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M59.822,55.524c-.065,0-.133,0-.2-.008a2.138,2.138,0,0,1-1.563-.682,1.265,1.265,0,0,1-.292-.594l-.007-.049h.049a19.841,19.841,0,0,1,3.716.35l.005.016-.006.016a1.827,1.827,0,0,1-1.7.952m-1.961-1.247a1.288,1.288,0,0,0,.266.505,2.111,2.111,0,0,0,1.5.647,1.759,1.759,0,0,0,1.794-.852,26.083,26.083,0,0,0-3.559-.3",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M58.3,54.7a.333.333,0,0,1-.007-.044l.191-1.18.044-.271a9.167,9.167,0,0,0,2.489.952l-.245.933",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M60.772,55.151l-.016,0a.062.062,0,0,1-.044-.076l.229-.873a9.365,9.365,0,0,1-2.367-.893l-.219,1.349.006.03a.062.062,0,0,1-.122.026.4.4,0,0,1-.008-.053v-.014l.234-1.451a.064.064,0,0,1,.037-.047.059.059,0,0,1,.059.005,9,9,0,0,0,2.47.943.071.071,0,0,1,.039.029.064.064,0,0,1,.006.047l-.245.934a.062.062,0,0,1-.06.046",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M60.814,55.1l-.085-.022.234-.891a9.29,9.29,0,0,1-2.4-.91l-.224,1.382.006.031-.086.018a.352.352,0,0,1-.008-.051l.247-1.528.056.038a9.081,9.081,0,0,0,2.476.946l.044.011Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M58.674,52.3l2.634.752-.213.81-.078.3a9.172,9.172,0,0,1-2.49-.952Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M61.048,54.209l-.042-.01a9.14,9.14,0,0,1-2.5-.958l-.024-.016.159-.983,2.723.778Zm-2.473-1.026a9.069,9.069,0,0,0,2.41.92l.269-1.022-2.545-.727Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M56.061,44.7s-1.325,1.689-.582,2.452c0,0-.928,1.5.1,2.28,0,0-.188,2.111,1.514,2.519l1.973-6.983Z",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M66.81,47.738s.245,2.132-.787,2.394c0,0,.008,1.761-1.282,1.888,0,0-.945,1.9-2.609,1.355l1.973-6.984Z",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M57.51,39.923s-2.211-.535-2.167,1.188c0,0-1.84.271-.932,1.9,0,0-.787,1.883,1.082,2.169,0,0,.133,1.852,2.6,1.53a1.887,1.887,0,0,0,2.528-1.218,2.14,2.14,0,0,0,.723-2.221s.775-1-.472-2.091c0,0,.291-.916-1.235-1.063,0,0-1.046-1.351-2.127-.2",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M61.937,45.623A2.936,2.936,0,1,1,59.91,42a2.936,2.936,0,0,1,2.027,3.624",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M59.116,47.824a3.033,3.033,0,0,1-.82-.114,2.983,2.983,0,1,1,.82.114m-.009-5.875a2.887,2.887,0,1,0,.786.11,2.861,2.861,0,0,0-.786-.11",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M66.572,47.164a8.13,8.13,0,0,1-.715,3.554,5.033,5.033,0,0,1-5.874,2.592c-2.633-.591-4.6-2.112-4.538-5.408s1.971-5.167,5.46-4.79c3.437.371,5.555,2.072,5.667,4.052",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M59.982,53.31c.537-.451-4-5.859-4.538-5.408",
    fill: "#3a2924"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M63.918,49.87s2.286-.035,1.885,1.719a1.258,1.258,0,0,1-2.5.073",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M64.594,52.819h-.013a1.414,1.414,0,0,1-1.341-1.145.062.062,0,0,1,.122-.025,1.306,1.306,0,0,0,1.22,1.046h.012c.559,0,.988-.418,1.148-1.12a1.173,1.173,0,0,0-.178-1.046,2.4,2.4,0,0,0-1.645-.6h0a.062.062,0,0,1,0-.124,2.471,2.471,0,0,1,1.743.643,1.289,1.289,0,0,1,.2,1.151,1.352,1.352,0,0,1-1.269,1.217",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M63.864,51.928a.038.038,0,0,0,.015,0,.035.035,0,0,0,.03-.041c0-.01-.136-.945.553-1.168a.8.8,0,0,1,.638.028,1,1,0,0,1,.424.544.036.036,0,0,0,.044.025.034.034,0,0,0,.025-.044,1.041,1.041,0,0,0-.459-.589.864.864,0,0,0-.694-.032c-.747.241-.6,1.237-.6,1.247a.037.037,0,0,0,.026.029",
    fill: "#2e2521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M64.909,51.492a.037.037,0,0,0,.032-.006.036.036,0,0,0,.006-.051c0-.006-.466-.594-1.019-.284a.036.036,0,1,0,.035.063c.5-.28.923.26.927.265a.035.035,0,0,0,.019.013",
    fill: "#2e2521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M66,47.074a9.82,9.82,0,0,1-.777,3.638,4.67,4.67,0,0,1-5.27,2.878c-2.288-.489-3.95-1.951-3.76-5.3s1.949-5.328,5-5.092c3,.233,4.792,1.871,4.808,3.876",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M60.921,53.755a4.661,4.661,0,0,1-.981-.1c-2.7-.576-3.978-2.381-3.809-5.364a5.814,5.814,0,0,1,1.7-4.174,4.4,4.4,0,0,1,3.366-.977c2.894.225,4.849,1.807,4.866,3.937a10.006,10.006,0,0,1-.782,3.663,4.808,4.808,0,0,1-4.359,3.02M60.705,43.24a4.1,4.1,0,0,0-2.794.966,5.7,5.7,0,0,0-1.656,4.087c-.165,2.913,1.083,4.674,3.711,5.236a4.537,4.537,0,0,0,.954.1,4.683,4.683,0,0,0,4.245-2.943,9.881,9.881,0,0,0,.773-3.613h0c-.016-2.063-1.926-3.6-4.751-3.815-.164-.013-.325-.019-.482-.019",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M60.617,42.722C55.4,41.249,55.453,47.7,55.453,47.7l.661.828a1.333,1.333,0,0,0,1.039-1.389A1.4,1.4,0,0,0,58.461,45.9a1.785,1.785,0,0,0,1.787-.732,2.1,2.1,0,0,0,1.034,1.035,1.356,1.356,0,0,0,1.4,1.415,2.694,2.694,0,0,0,1.463,2.1s.223.474,1.609.688a26.066,26.066,0,0,1,1.053-2.672c.619-1.348-.664-5.045-6.193-5.016",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M56.795,47.838s-1.512-1.089-2.088.615A1.258,1.258,0,0,0,56.8,49.825",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M55.79,50.329a1.328,1.328,0,0,1-.685-.187,1.625,1.625,0,0,1,.359-2.657,1.749,1.749,0,0,1,1.368.3.061.061,0,0,1,.014.086.062.062,0,0,1-.087.014A1.651,1.651,0,0,0,55.5,47.6a1.506,1.506,0,0,0-.333,2.433,1.306,1.306,0,0,0,1.587-.253.062.062,0,1,1,.091.085,1.456,1.456,0,0,1-1.057.461",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M56.182,49.758a.033.033,0,0,1-.013-.007.036.036,0,0,1,0-.051c.006-.007.611-.734.14-1.284a.8.8,0,0,0-.557-.311.994.994,0,0,0-.647.243.036.036,0,0,1-.049-.053,1.049,1.049,0,0,1,.7-.262.869.869,0,0,1,.609.336c.51.6-.133,1.37-.14,1.378a.035.035,0,0,1-.037.011",
    fill: "#2e2521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M55.52,48.84a.036.036,0,0,1,0-.068c.007,0,.708-.263,1.017.291a.036.036,0,0,1-.013.049.037.037,0,0,1-.049-.014c-.28-.5-.923-.261-.929-.259a.037.037,0,0,1-.023,0",
    fill: "#2e2521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M58.736,47.763s-.238-.415.607-.55,1.069.032,1.122.261c.048.207-.2.409-.679.476-.572.08-.924.048-1.05-.187",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M59.62,49.43a.371.371,0,1,1-.2-.536.409.409,0,0,1,.2.536",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M62.69,50.953a.452.452,0,1,1,.486-.3.41.41,0,0,1-.486.3",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M64.17,49.545s.441-.187-.149-.806-.871-.621-1.05-.472-.087.449.251.79c.407.41.7.6.948.488",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M61.076,50.878a.034.034,0,0,1-.024-.03.036.036,0,0,1,.032-.04.972.972,0,0,0,.522-.238.613.613,0,0,0,.142-.625.254.254,0,0,0-.294-.12l-.022,0c-.5.1-.654-.071-.694-.234a4.732,4.732,0,0,1,.51-1.515.037.037,0,0,1,.047-.019.036.036,0,0,1,.019.047,4.562,4.562,0,0,0-.506,1.47c.047.193.252.254.61.181l.025,0a.324.324,0,0,1,.369.158.682.682,0,0,1-.155.709,1.034,1.034,0,0,1-.566.259.039.039,0,0,1-.015,0",
    fill: "#2e2521"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    transform: "translate(55.641 49.941)",
    fill: "#d48b36"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    transform: "translate(64.811 52.532)",
    fill: "#d48b36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M61.825,50.161a1.759,1.759,0,0,1,2.266-1.115A1.864,1.864,0,0,1,65.164,51.4,1.758,1.758,0,0,1,62.9,52.515a1.864,1.864,0,0,1-1.073-2.354m.089.033a1.765,1.765,0,0,0,1.016,2.229,1.665,1.665,0,0,0,2.146-1.055,1.765,1.765,0,0,0-1.016-2.229,1.664,1.664,0,0,0-2.146,1.055",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M56.961,48.454a1.892,1.892,0,1,1,1.145,2.419,1.9,1.9,0,0,1-1.145-2.419m.1.034a1.792,1.792,0,1,0,2.29-1.084,1.794,1.794,0,0,0-2.29,1.084",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M60.549,49.51a.046.046,0,0,0,.026,0,1.541,1.541,0,0,1,1.372.49.051.051,0,0,0,.071.007.05.05,0,0,0,.006-.071,1.648,1.648,0,0,0-1.467-.525.051.051,0,0,0-.041.059.053.053,0,0,0,.033.038",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M61.159,51.664a.805.805,0,0,0,.148-.2,3.974,3.974,0,0,0-1.064-.639,1.1,1.1,0,0,0-.086.268,2.991,2.991,0,0,1,1,.575",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M61.16,51.706l-.023-.018a2.944,2.944,0,0,0-.99-.57l-.025-.009,0-.025a1.042,1.042,0,0,1,.089-.276l.013-.025.026.01a4.008,4.008,0,0,1,1.073.644l.017.015-.01.021a.808.808,0,0,1-.154.214Zm-.966-.638a3.024,3.024,0,0,1,.962.553.73.73,0,0,0,.113-.155,3.97,3.97,0,0,0-1.01-.6,1.1,1.1,0,0,0-.065.206",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M60.158,51.089a.561.561,0,0,0,.266.64.566.566,0,0,0,.735-.065,3,3,0,0,0-1-.575",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M60.774,51.863a.748.748,0,0,1-.365-.107.592.592,0,0,1-.281-.673.027.027,0,0,1,.015-.021.028.028,0,0,1,.025,0,3.023,3.023,0,0,1,1.011.581.03.03,0,0,1,.011.023.033.033,0,0,1-.009.023.577.577,0,0,1-.407.177m-.591-.733a.524.524,0,0,0,.256.572.54.54,0,0,0,.674-.038,2.979,2.979,0,0,0-.93-.534",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M63.474,58.73a8.776,8.776,0,0,0-1.355-3.805l.036-.025a8.819,8.819,0,0,1,1.363,3.825Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M54.972,59.2l-.044-.005a8.525,8.525,0,0,1,1.836-4.9l.031.032A8.473,8.473,0,0,0,54.972,59.2",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M54.818,59.808l.051-.45s-1.9-.186-2.453-1.153l-.173.526s.574.929,2.575,1.077",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M54.818,59.852h0c-2-.148-2.585-1.059-2.609-1.1a.044.044,0,0,1,0-.037l.173-.526a.044.044,0,0,1,.037-.03.046.046,0,0,1,.043.022c.531.936,2.4,1.13,2.419,1.131a.043.043,0,0,1,.03.016.05.05,0,0,1,.01.033l-.052.45a.043.043,0,0,1-.043.039m-2.527-1.128a3.286,3.286,0,0,0,2.488,1.037l.041-.364a3.747,3.747,0,0,1-2.392-1.089Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M62.392,59.97l.388,1.508a5.418,5.418,0,0,0,2.391-.914c-.3-.982-.591-1.859-.591-1.859a3.753,3.753,0,0,1-2.188,1.265",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M62.779,61.541a.062.062,0,0,1-.06-.047l-.388-1.508a.064.064,0,0,1,.008-.049.073.073,0,0,1,.041-.028,3.717,3.717,0,0,0,2.15-1.241.061.061,0,0,1,.108.018c0,.008.3.889.592,1.86a.061.061,0,0,1-.025.069,5.5,5.5,0,0,1-2.418.925h-.008m-.311-1.522.357,1.392a5.4,5.4,0,0,0,2.273-.873c-.229-.756-.457-1.45-.542-1.707a3.826,3.826,0,0,1-2.088,1.188",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M62.935,62.086l1.986,2.523a2.115,2.115,0,0,0,.793-1.991c-.1-.529-.323-1.321-.544-2.054a5.41,5.41,0,0,1-2.391.915Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M64.921,64.671a.063.063,0,0,1-.049-.024l-1.985-2.524a.046.046,0,0,1-.012-.023l-.156-.606a.065.065,0,0,1,.009-.051.063.063,0,0,1,.044-.026,5.4,5.4,0,0,0,2.364-.9.06.06,0,0,1,.055-.007.064.064,0,0,1,.039.04c.275.913.458,1.606.545,2.06a2.2,2.2,0,0,1-.818,2.054.062.062,0,0,1-.036.012m-1.929-2.614,1.939,2.464a2.045,2.045,0,0,0,.722-1.892c-.083-.437-.257-1.1-.518-1.967a5.517,5.517,0,0,1-2.278.869Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M65.07,65.078l-7.529-.961A2.116,2.116,0,0,1,55.71,61.75l.494-3.87a2.116,2.116,0,0,1,2.367-1.831l7.529.961a2.116,2.116,0,0,1,1.831,2.367l-.494,3.87a2.116,2.116,0,0,1-2.367,1.831",
    fill: "#4c5bdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M66.473,65.313a.828.828,0,0,1-.111-.007L56.234,64.013a.867.867,0,0,1-.751-.971l.826-6.469a.869.869,0,0,1,.971-.751l10.128,1.293a.869.869,0,0,1,.751.971l-.826,6.469a.869.869,0,0,1-.86.758m-.1-.13a.745.745,0,0,0,.832-.643l.826-6.47a.745.745,0,0,0-.644-.832L57.264,55.945a.745.745,0,0,0-.832.644l-.826,6.469a.743.743,0,0,0,.644.832Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M61.749,61.659a.925.925,0,0,1-.712-.331l-4.313-5.176a.062.062,0,1,1,.1-.079l4.313,5.175a.8.8,0,0,0,1.079.14l5.575-3.964a.063.063,0,0,1,.087.015.061.061,0,0,1-.015.086l-5.575,3.964a.915.915,0,0,1-.534.17",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 3.068,
    y2: 4.638,
    transform: "translate(63.78 60.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M66.848,65.172a.063.063,0,0,1-.052-.028l-3.068-4.637a.062.062,0,0,1,.018-.086.063.063,0,0,1,.086.017L66.9,65.076a.062.062,0,0,1-.018.086.059.059,0,0,1-.034.01",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 4.135,
    y2: 3.718,
    transform: "translate(55.851 59.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M55.851,63.768a.062.062,0,0,1-.041-.108l4.135-3.718a.062.062,0,1,1,.082.092l-4.135,3.718a.057.057,0,0,1-.041.016",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M60.635,63.189c-.162-.291-1.369.248-1.369.248s1.555-.749,1.357-.917c-.136-.116-.844.1-1.275.251-.192.073-.336.121-.336.121s.139-.053.336-.121c.438-.167,1.126-.465.924-.628-.289-.234-1.885.468-1.885.468s.82-1.088.25-.992a4.4,4.4,0,0,0-1.492.971,9.91,9.91,0,0,0-3.014-.493l.555.045.09-1.678a4.841,4.841,0,0,1-2.459-.589c-.113.929-.268,2.352-.268,3.154a2.115,2.115,0,0,0,1.15,1.808,13.1,13.1,0,0,0,4.361-.313,3.782,3.782,0,0,0,2.9-.669c-.058-.259-1.109.116-1.109.116s1.425-.535,1.288-.782",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M54.318,64.992a6.063,6.063,0,0,1-1.131-.094.044.044,0,0,1-.015-.005,2.192,2.192,0,0,1-1.186-1.864c0-.787.146-2.153.269-3.161a.06.06,0,0,1,.033-.048.062.062,0,0,1,.059,0,4.8,4.8,0,0,0,2.428.58.069.069,0,0,1,.045.019.065.065,0,0,1,.018.047l-.087,1.617a9.216,9.216,0,0,1,2.381.434,4.174,4.174,0,0,1,1.494-.96c.121-.02.2.005.247.075.1.172-.139.585-.308.835.477-.2,1.49-.58,1.746-.373a.14.14,0,0,1,.057.136c-.005.034-.017.109-.228.242.417-.091.492-.027.523,0a.108.108,0,0,1,.038.1c-.016.126-.315.332-.642.52.283-.067.547-.08.63.068a.142.142,0,0,1,.007.12c-.05.133-.311.294-.592.434a.608.608,0,0,1,.332.025.16.16,0,0,1,.08.1.139.139,0,0,1-.048.117,4.2,4.2,0,0,1-2.907.628,16.283,16.283,0,0,1-3.243.4m-1.1-.214a13.146,13.146,0,0,0,4.326-.315.062.062,0,0,1,.027,0,4.034,4.034,0,0,0,2.819-.6.033.033,0,0,0-.015-.013,2.205,2.205,0,0,0-1.009.182.062.062,0,1,1-.042-.116,3.536,3.536,0,0,0,1.254-.677c.005-.011,0-.015,0-.017-.091-.165-.823.066-1.289.274a.063.063,0,0,1-.082-.03.062.062,0,0,1,.03-.082,4.874,4.874,0,0,0,1.337-.818c-.036-.019-.239-.067-1.208.267-.192.072-.337.121-.337.121a.064.064,0,0,1-.078-.038.062.062,0,0,1,.037-.079s.139-.054.337-.122c.659-.25.907-.427.919-.5,0,0,0-.009-.013-.02-.19-.153-1.218.211-1.822.477a.062.062,0,0,1-.074-.094c.256-.34.494-.772.43-.876-.018-.03-.083-.024-.12-.018a4.387,4.387,0,0,0-1.46.955.062.062,0,0,1-.068.012,8.713,8.713,0,0,0-2.425-.444H54.68l-.554-.044a.062.062,0,0,1-.057-.066.063.063,0,0,1,.066-.058c.173.012.336.024.492.038l.083-1.547a4.939,4.939,0,0,1-2.343-.553c-.12.995-.257,2.3-.257,3.056a2.062,2.062,0,0,0,1.109,1.749",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M54.776,60.463l.042-.655a3.759,3.759,0,0,1-2.386-.835s-.051.371-.115.9a4.842,4.842,0,0,0,2.459.588",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M54.692,60.526a4.892,4.892,0,0,1-2.406-.6.062.062,0,0,1-.031-.062c.064-.531.115-.9.115-.9a.064.064,0,0,1,.041-.05.061.061,0,0,1,.062.012,3.732,3.732,0,0,0,2.313.819h.032a.064.064,0,0,1,.045.019.059.059,0,0,1,.016.047l-.041.655a.062.062,0,0,1-.061.058h-.085m.084-.063h0Zm-2.393-.622a4.783,4.783,0,0,0,2.309.561h.026l.034-.532a3.832,3.832,0,0,1-2.274-.778c-.019.142-.054.411-.1.749",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M59.347,62.771c-.2.068-.336.121-.336.121s.144-.048.336-.121",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M59.012,62.954a.062.062,0,0,1-.022-.12s.14-.053.338-.121a.061.061,0,0,1,.078.037.062.062,0,0,1-.036.079c-.193.074-.339.122-.339.122l-.019,0",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M68.637,58.51a.492.492,0,0,0-.569-.407,1.8,1.8,0,0,0-.628.166c-.516.256.777.249.777.249s-1.254.207-1.349.566,1.011.026,1.011.026-1.036.358-1.1.61S68,59.7,68,59.7s-.9.161-.861.492c.036.279,1.111-.013,1.111-.013s-.717.176-.611.42c0,0,.108.3.967-.278.461-.309.205-1.269.034-1.81",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M67.805,60.737a.352.352,0,0,1-.106-.016.181.181,0,0,1-.12-.1.177.177,0,0,1,.006-.155.327.327,0,0,1,.094-.109.908.908,0,0,1-.528-.039.166.166,0,0,1-.076-.118c-.017-.133.079-.239.214-.323-.241.023-.463.019-.536-.056a.121.121,0,0,1-.03-.114c.032-.133.264-.278.513-.4a.537.537,0,0,1-.387-.066.164.164,0,0,1-.04-.172c.062-.238.527-.406.906-.506-.283-.026-.436-.08-.455-.164s.1-.161.153-.185a1.831,1.831,0,0,1,.65-.172.553.553,0,0,1,.634.45c.119.376.48,1.519-.059,1.88a1.752,1.752,0,0,1-.833.366m.408-.486c-.19.053-.464.16-.517.268a.058.058,0,0,0,0,.054s.011.022.053.033c.084.021.305.008.822-.338.307-.205.31-.791.01-1.74-.09-.282-.235-.388-.505-.363a1.707,1.707,0,0,0-.606.159.365.365,0,0,0-.078.048,2.855,2.855,0,0,0,.827.084.061.061,0,0,1,.062.056.062.062,0,0,1-.051.067c-.47.077-1.238.287-1.3.52-.01.036,0,.047.006.052.1.094.6,0,.927-.1a.062.062,0,0,1,.038.118c-.417.144-1.02.414-1.056.565a2.439,2.439,0,0,0,1.029-.073l.113-.023a.062.062,0,0,1,.072.049.061.061,0,0,1-.048.072l-.109.023c-.292.067-.726.219-.7.4a.043.043,0,0,0,.022.031,2,2,0,0,0,.962-.082l.051-.013a.061.061,0,0,1,.075.044.063.063,0,0,1-.044.076l-.051.013",
    fill: "#222221"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M79.616,82l11.5.525s.536-5.342-.4-6.728a4.535,4.535,0,0,0-3.037-1.779l-4.814-.164a4.058,4.058,0,0,0-2.975,1.293,31.208,31.208,0,0,1-2.558,2.248",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M91.115,82.585h0l-11.5-.525A.062.062,0,0,1,79.554,82a.059.059,0,0,1,.065-.06l11.44.522c.054-.584.465-5.354-.4-6.628a4.5,4.5,0,0,0-2.991-1.752l-4.81-.163a4.023,4.023,0,0,0-2.928,1.274,31.69,31.69,0,0,1-2.564,2.253.062.062,0,0,1-.087-.01.063.063,0,0,1,.01-.087A31.511,31.511,0,0,0,79.84,75.1a4.157,4.157,0,0,1,3.023-1.312l4.812.163a4.635,4.635,0,0,1,3.086,1.806c.943,1.389.438,6.55.416,6.769a.063.063,0,0,1-.062.056",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M76.918,75.472a29.084,29.084,0,0,0-.474-2.975,3.7,3.7,0,0,1-2.959.283,21.3,21.3,0,0,0,.412,5.269s.77,4.784,4.694,3.345a17.206,17.206,0,0,1-.867-4.259Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M77.208,81.725a2.734,2.734,0,0,1-1.4-.371,4.119,4.119,0,0,1-1.582-2,6.407,6.407,0,0,1-.387-1.3,21.445,21.445,0,0,1-.413-5.282.063.063,0,0,1,.025-.047.066.066,0,0,1,.053-.01,3.678,3.678,0,0,0,2.907-.274.062.062,0,0,1,.056-.008.061.061,0,0,1,.039.042,28.041,28.041,0,0,1,.475,2.974l.8,1.654a.046.046,0,0,1,.005.02,17.569,17.569,0,0,0,.863,4.243.061.061,0,0,1,0,.048.066.066,0,0,1-.035.033,4.105,4.105,0,0,1-1.4.273m-3.663-8.866a20.791,20.791,0,0,0,.412,5.173c.006.031.392,2.325,1.913,3.215a3.042,3.042,0,0,0,2.641.11,17.961,17.961,0,0,1-.847-4.205l-.8-1.653a.066.066,0,0,1-.006-.02c0-.021-.231-2.039-.45-2.885a3.832,3.832,0,0,1-2.862.265",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M77.725,77.135a17.185,17.185,0,0,0,.865,4.259,6.909,6.909,0,0,0,.978-.455Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M78.59,81.456a.061.061,0,0,1-.057-.039,17.693,17.693,0,0,1-.871-4.275.062.062,0,0,1,.045-.066.063.063,0,0,1,.073.033l1.844,3.8a.062.062,0,0,1-.026.081,6.967,6.967,0,0,1-.986.46.078.078,0,0,1-.022,0m-.765-3.97a16.97,16.97,0,0,0,.8,3.829,6.857,6.857,0,0,0,.861-.4Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M82.963,74.158c.194.365.748.934,2.319.989,1.628.057,2.331-.4,2.626-.739a21.1,21.1,0,0,0-4.945-.25",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M85.553,75.234c-.089,0-.18,0-.275-.005-1.629-.056-2.2-.671-2.388-1.033a.082.082,0,0,1,.067-.121,21.093,21.093,0,0,1,4.965.251.084.084,0,0,1,.064.054.082.082,0,0,1-.016.082,3.054,3.054,0,0,1-2.417.772m-2.448-1c.231.331.8.785,2.179.833a3.4,3.4,0,0,0,2.452-.6,21.005,21.005,0,0,0-4.631-.232",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M87.908,74.408a.931.931,0,0,0,.2-.331c-4.147-.542-5.25-.224-5.25-.224a.859.859,0,0,0,.1.305,21.093,21.093,0,0,1,4.945.25",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M87.94,74.5l-.046-.008a20.946,20.946,0,0,0-4.925-.249l-.054,0L82.89,74.2a.96.96,0,0,1-.114-.337l-.006-.068.066-.018c.046-.013,1.167-.317,5.284.221l.093.012-.024.091a.973.973,0,0,1-.219.365Zm-3.579-.471a21.066,21.066,0,0,1,3.514.292,1.057,1.057,0,0,0,.116-.174,18.808,18.808,0,0,0-5.035-.227.9.9,0,0,0,.057.154c.341-.024.8-.045,1.348-.045",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M84.073,74.646l-.017-.768,0-.268a8.937,8.937,0,0,0,2.55.488l-.077.541",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M84.073,74.729a.083.083,0,0,1-.083-.081l-.021-1.036A.083.083,0,0,1,84,73.541a.087.087,0,0,1,.08-.007,8.758,8.758,0,0,0,2.521.481.085.085,0,0,1,.059.03.082.082,0,0,1,.018.064l-.077.542a.083.083,0,0,1-.094.07.082.082,0,0,1-.07-.093l.064-.454a9.217,9.217,0,0,1-2.37-.439l.02.909a.083.083,0,0,1-.081.085Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M84.036,72.321l2.653.271L86.625,73.8l-.025.3a8.927,8.927,0,0,1-2.549-.487Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M86.677,74.186,86.6,74.18a8.918,8.918,0,0,1-2.576-.494l-.049-.021-.018-1.435,2.825.288-.069,1.287Zm-2.543-.631a8.818,8.818,0,0,0,2.391.454l.017-.215.06-1.127-2.482-.254Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M81.139,67.5a1.831,1.831,0,0,1,.018-1.923,3.158,3.158,0,0,1,1.025-1.1l.035.009.006.04-.05,0h0v0l0,.04a3.721,3.721,0,0,0-.936,1.054,1.734,1.734,0,0,0-.023,1.818Zm1.031-2.971-.043,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M90.825,70.468l0-.1A1.394,1.394,0,0,0,91.938,68.2l-.025-.037.036-.028a1.837,1.837,0,0,0-1.212-3.286l0-.1a1.934,1.934,0,0,1,1.31,3.432,1.491,1.491,0,0,1-1.218,2.285"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M85.938,72.484l-.3.756a5.577,5.577,0,0,1-2.477-.686l.326-1.115Z",
    fill: "#d8a079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M82.965,64.39a6.806,6.806,0,0,0-1.286,3.181,4.061,4.061,0,0,0,2.486,4.8c2.015.765,4.54.665,5.931-2.1,1.172-2.325,1.234-4.974-1.186-6.418s-4.893-.89-5.945.534",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M86.263,72.842a6.062,6.062,0,0,1-2.12-.415,4.106,4.106,0,0,1-2.525-4.869,6.828,6.828,0,0,1,1.3-3.205c1.03-1.395,3.492-2.062,6.027-.55,2.159,1.288,2.611,3.718,1.209,6.5a4.294,4.294,0,0,1-2.771,2.4,4.444,4.444,0,0,1-1.117.139m-3.248-8.415a6.728,6.728,0,0,0-1.276,3.158,3.984,3.984,0,0,0,2.448,4.726c3.647,1.384,5.309-.983,5.854-2.065,1.369-2.717.935-5.086-1.162-6.337-2.473-1.474-4.867-.834-5.864.518m-.05-.037h0Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M84.53,61.925c-.69.133-.034.131-.587.564s-2.251,1.4-1.907,2.007c-.264.374-1.281,1.834-.972,3.08.1.422.352.607.753.439a2.157,2.157,0,0,0,.851-1.174,5.723,5.723,0,0,0,.464-1.321,10.7,10.7,0,0,0,1.752-1.476,1.977,1.977,0,0,0,.6-.982.778.778,0,0,0-.528-.91",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M90.09,69.938s-.727-.422-.4-1.814c0,0-.578-.475-.377-1.9,0,0-3.9.263-4.676-.706a.688.688,0,0,1,.086-.868,1.9,1.9,0,0,1-1.555-.386c-.881-.6.086-1.855.777-1.841a1.354,1.354,0,0,1,2.121-1.078,19.332,19.332,0,0,0,3.459,1.069,2.617,2.617,0,0,1,1.734,2.021s2.262,2.318.747,3.649c0,0,.362,1.917-1,2.139s-.91-.28-.91-.28",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M91.238,65.076a3.683,3.683,0,0,0,.924-.561c.063-.053.127-.149.068-.206s-.118-.017-.174.011l-.593.306a2.528,2.528,0,0,0,.609-.759c.056-.107.1-.25.017-.337a.212.212,0,0,0-.252-.02.623.623,0,0,0-.188.194l-.77,1.069",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M82.195,69.142a6.483,6.483,0,0,0,.035-1.83s-1.37-1.034-1.935.524,1.442,2.394,1.9,1.306",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M81.434,69.695a1.248,1.248,0,0,1-.445-.085,1.355,1.355,0,0,1-.753-1.795,1.254,1.254,0,0,1,.774-.861,1.615,1.615,0,0,1,1.257.309.058.058,0,0,1,.024.043,6.3,6.3,0,0,1-.04,1.86.842.842,0,0,1-.817.529m-.139-2.657a.858.858,0,0,0-.25.035,1.138,1.138,0,0,0-.692.784,1.22,1.22,0,0,0,.682,1.637.8.8,0,0,0,1.1-.376,6.133,6.133,0,0,0,.034-1.772,1.714,1.714,0,0,0-.876-.308",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M81.626,69.068l-.012-.007a.033.033,0,0,1,0-.047c.006-.006.577-.663.155-1.18a.736.736,0,0,0-.507-.3.909.909,0,0,0-.6.21.034.034,0,0,1-.047,0,.033.033,0,0,1,0-.047.96.96,0,0,1,.649-.226.8.8,0,0,1,.554.321c.457.561-.151,1.259-.157,1.266a.034.034,0,0,1-.035.01",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M81.035,68.208a.033.033,0,0,1,0-.063c.006,0,.657-.227.931.289a.033.033,0,1,1-.059.031c-.247-.466-.844-.26-.85-.257a.038.038,0,0,1-.021,0",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M89.886,69.673s-1.1,5.073-5.636,3.585c-4.166-1.368-2.131-5.981-2.131-5.981s.328.153,1.107,1.743c.418.856,1.337.41,2.132.7s1.1.55,1.992.846,1.27-1.306,2.536-.894",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M85,70.616a.525.525,0,0,0,.666-.241.034.034,0,0,0-.017-.044.034.034,0,0,0-.044.017c-.007.015-.179.378-.672.173a.034.034,0,0,0-.044.018.033.033,0,0,0,.018.043.815.815,0,0,0,.093.034",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M88.8,71.169a6.437,6.437,0,0,1,1-1.535s1.714-.087,1.309,1.519-2.537,1.174-2.306.016",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M89.834,72.265a1.388,1.388,0,0,1-.3-.033.931.931,0,0,1-.8-1.075,6.321,6.321,0,0,1,1.011-1.563.063.063,0,0,1,.044-.022,1.619,1.619,0,0,1,1.214.45,1.252,1.252,0,0,1,.158,1.146,1.359,1.359,0,0,1-1.33,1.1m-.975-1.084h0a.8.8,0,0,0,.7.93,1.222,1.222,0,0,0,1.483-.973A1.135,1.135,0,0,0,90.91,70.1a1.49,1.49,0,0,0-1.085-.406,6.14,6.14,0,0,0-.966,1.486",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M88.487,68.479s.4-.184-.158-.739-.817-.55-.979-.408-.069.417.252.722c.384.367.664.534.885.425",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M86.9,69.21a.342.342,0,1,0,.44-.292.378.378,0,0,0-.44.292",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M83.347,66.93s-.229-.377.545-.523.985,0,1.039.212c.05.19-.176.383-.613.456-.524.087-.849.069-.971-.145",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M84.437,68.435a.342.342,0,1,1-.2-.489.377.377,0,0,1,.2.489",
    fill: "#040602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M89.311,71.426a.032.032,0,0,0,.014,0,.034.034,0,0,0,.029-.037c0-.009-.106-.873.533-1.064a.738.738,0,0,1,.587.038.915.915,0,0,1,.379.511.033.033,0,0,0,.064-.017.965.965,0,0,0-.41-.551.8.8,0,0,0-.639-.044c-.694.207-.581,1.126-.58,1.136a.034.034,0,0,0,.023.027",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M90.283,71.046a.03.03,0,0,0,.029,0A.032.032,0,0,0,90.319,71c0-.006-.416-.557-.932-.283a.032.032,0,0,0-.014.045.033.033,0,0,0,.045.013c.465-.247.844.259.848.264a.03.03,0,0,0,.017.012",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M85.216,69.53a.034.034,0,0,0,.035-.01.034.034,0,0,0,0-.047.892.892,0,0,1-.263-.458.565.565,0,0,1,.23-.544.233.233,0,0,1,.284.068l.014.015c.321.346.528.3.646.2a11.168,11.168,0,0,0,.7-2.252.033.033,0,0,0-.025-.039.033.033,0,0,0-.04.024,11,11,0,0,1-.675,2.217c-.138.119-.325.055-.553-.192l-.016-.017a.3.3,0,0,0-.361-.08.625.625,0,0,0-.265.613.936.936,0,0,0,.284.5l.012.007",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M83.944,62.418s1.364-1.316,2.12-1.078c2,.63,2.327.656,3.46,1.069",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    transform: "translate(89.77 71.942)",
    fill: "#d38b35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M79.6,81.988s.136-1.765.4-3.884",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M79.6,82.071h-.006a.084.084,0,0,1-.077-.089c0-.018.139-1.791.4-3.888a.083.083,0,0,1,.165.02c-.261,2.093-.4,3.863-.4,3.88a.084.084,0,0,1-.083.077",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x2: 0.513,
    y2: 3.049,
    transform: "translate(76.893 75.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M77.406,78.135a.084.084,0,0,1-.082-.069l-.512-3.049a.083.083,0,0,1,.068-.1.082.082,0,0,1,.1.068l.513,3.049a.084.084,0,0,1-.068.1h-.014",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M76.634,73.57a4.417,4.417,0,0,1-3.016.23l-.015-.511a4.1,4.1,0,0,0,2.959-.283Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M74.735,74.044a3.552,3.552,0,0,1-1.146-.166.083.083,0,0,1-.054-.076l-.015-.51a.084.084,0,0,1,.111-.081,4.047,4.047,0,0,0,2.894-.279.083.083,0,0,1,.119.064l.072.564a.083.083,0,0,1-.05.087,5.061,5.061,0,0,1-1.931.4M73.7,73.739a4.459,4.459,0,0,0,2.845-.222l-.05-.387a4.2,4.2,0,0,1-2.805.272Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M73.6,73.289a3.984,3.984,0,0,1,2.959-.283,4.152,4.152,0,0,1-2.959.283",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M74.75,73.508a5.111,5.111,0,0,1-1.166-.138.082.082,0,0,1-.063-.066.083.083,0,0,1,.036-.084,4.036,4.036,0,0,1,3.023-.295.084.084,0,0,1,.025.152,3.759,3.759,0,0,1-1.855.431m-.9-.252a4.277,4.277,0,0,0,2.462-.218,4.159,4.159,0,0,0-2.462.218",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M89.924,78.721a8.846,8.846,0,0,1-2.037,3.367,1.9,1.9,0,0,1-2.7-.2Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M86.7,82.658a2.4,2.4,0,0,1-1.558-.724.062.062,0,0,1-.016-.049.061.061,0,0,1,.027-.044l4.738-3.171a.06.06,0,0,1,.071,0,.061.061,0,0,1,.022.068,8.969,8.969,0,0,1-2.053,3.394,1.8,1.8,0,0,1-1.231.524M85.283,81.9a2.555,2.555,0,0,0,.767.5,1.6,1.6,0,0,0,1.795-.362A8.564,8.564,0,0,0,89.8,78.875Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M85.547,75.628c-.083,0-.168,0-.255,0a3.232,3.232,0,0,1-2.423-.888,1.511,1.511,0,0,1-.4-.826.045.045,0,0,1,.041-.047.047.047,0,0,1,.047.041c0,.015.14,1.537,2.737,1.632,2.177.079,2.917-.877,3.135-1.292.016-.03.026-.051.058-.049a.045.045,0,0,1,.038.031.042.042,0,0,1-.01.044l-.008.015c-.217.413-.932,1.344-2.961,1.344",
    fill: "#222221"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M76.047,75.911a4.579,4.579,0,0,1,2.461-1.667,3.161,3.161,0,0,1-2.464,1.668",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M76.044,76a.083.083,0,0,1-.082-.077.084.084,0,0,1,.022-.063,4.74,4.74,0,0,1,2.5-1.688.082.082,0,0,1,.09.022.084.084,0,0,1,.013.092A3.272,3.272,0,0,1,76.051,76h-.007m2.274-1.589a4.955,4.955,0,0,0-2.1,1.4,3.068,3.068,0,0,0,2.1-1.4",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M77.717,73.5l-7.148,1.087A2.014,2.014,0,0,1,68.274,72.9l-.559-3.674a2.016,2.016,0,0,1,1.69-2.3l7.148-1.086a2.014,2.014,0,0,1,2.295,1.69l.559,3.673a2.015,2.015,0,0,1-1.69,2.295",
    fill: "#4c5bdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M69.219,74.847a.828.828,0,0,1-.818-.7L67.467,68a.831.831,0,0,1,.695-.945L77.778,65.6a.829.829,0,0,1,.944.695l.934,6.142a.83.83,0,0,1-.695.944l-9.616,1.462a.889.889,0,0,1-.126.009M77.9,65.709a.784.784,0,0,0-.108.008l-9.615,1.462a.7.7,0,0,0-.591.8l.933,6.142a.7.7,0,0,0,.8.591l9.615-1.461a.706.706,0,0,0,.592-.8L78.6,66.309a.7.7,0,0,0-.7-.6",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M73.537,71.275a.879.879,0,0,1-.5-.152l-5.3-3.614a.062.062,0,0,1-.016-.086.062.062,0,0,1,.086-.017l5.3,3.614a.762.762,0,0,0,1.021-.153L78.2,65.779a.063.063,0,0,1,.087-.009.061.061,0,0,1,.009.087l-4.071,5.088a.885.885,0,0,1-.692.33",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 4.022,
    y2: 3.447,
    transform: "translate(75.332 69.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M79.354,73.129a.06.06,0,0,1-.04-.015l-4.022-3.446a.063.063,0,0,1-.007-.088.062.062,0,0,1,.087-.007l4.022,3.447a.062.062,0,0,1,.007.087.06.06,0,0,1-.047.022",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 2.816,
    y2: 4.486,
    transform: "translate(68.914 70.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M68.914,74.716a.066.066,0,0,1-.033-.009.063.063,0,0,1-.02-.086l2.817-4.486a.062.062,0,0,1,.085-.02.063.063,0,0,1,.02.086l-2.816,4.486a.062.062,0,0,1-.053.029",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M76.812,76.159c-.224-.354-.353-.58-.353-.58a3.6,3.6,0,0,1-1.489-2.407c.215-.135.666.828.666.828s-.594-1.323-.335-1.4c.306-.086.75,1.092.75,1.092s-.536-1.554-.289-1.533c.169.015.5.641.685,1.032.079.178.143.308.143.308s-.057-.13-.143-.308c-.181-.408-.44-1.074-.195-1.047.353.039.947,1.59.947,1.59s.186-1.284.5-.834a2.078,2.078,0,0,1,.252,1.185s.3.188.809.563",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M76.812,76.221a.06.06,0,0,1-.052-.029c-.194-.305-.317-.517-.347-.569a4,4,0,0,1-1.524-2.39.133.133,0,0,1,.048-.114.153.153,0,0,1,.126-.015.557.557,0,0,1,.231.193,1.24,1.24,0,0,1-.1-.675.141.141,0,0,1,.088-.078c.042-.011.212-.027.46.361-.088-.34-.145-.668-.072-.762a.1.1,0,0,1,.1-.041c.039,0,.131.011.342.339-.046-.216-.005-.272.017-.3a.14.14,0,0,1,.133-.054c.31.035.728.965.916,1.424.058-.293.172-.715.359-.76.077-.018.151.021.219.118a2.069,2.069,0,0,1,.265,1.189c.09.058.369.241.782.545a.063.063,0,0,1,.013.087.062.062,0,0,1-.087.013c-.5-.369-.8-.559-.805-.561a.061.061,0,0,1-.029-.058,2.03,2.03,0,0,0-.24-1.144c-.016-.023-.059-.075-.089-.068-.112.027-.244.476-.3.876a.062.062,0,0,1-.12.013c-.224-.586-.666-1.525-.9-1.55-.016,0-.018,0-.019,0s-.081.148.277.957c.086.178.144.308.144.308a.062.062,0,0,1-.113.052s-.064-.13-.144-.31c-.416-.862-.584-.977-.625-.992a4.782,4.782,0,0,0,.345,1.448.062.062,0,0,1-.117.042c-.2-.54-.517-1.1-.675-1.054,0,0,0,0-.009.01a3.354,3.354,0,0,0,.383,1.3.062.062,0,0,1-.113.051c-.134-.287-.4-.759-.551-.8l-.015,0a3.88,3.88,0,0,0,1.481,2.307.055.055,0,0,1,.019.021s.13.228.351.577a.061.061,0,0,1-.019.085.058.058,0,0,1-.033.01",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 13.729,
    transform: "translate(78.792 81.971)",
    fill: "#b4bed5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M90.128,78.468a21.265,21.265,0,0,1-2.684,3.09c-4.626,3.29-8.509-1.219-8.509-1.219a21.324,21.324,0,0,1-2.887-4.427,3.7,3.7,0,0,0,2.461-1.667c.587.6,5.09,4.117,5.09,4.117a16.6,16.6,0,0,1,2.912-2.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M83.971,82.813a7.539,7.539,0,0,1-5.084-2.434,21.49,21.49,0,0,1-2.9-4.441.062.062,0,0,1,0-.053.06.06,0,0,1,.042-.034,3.679,3.679,0,0,0,2.42-1.634.062.062,0,0,1,.046-.034.061.061,0,0,1,.054.018c.546.554,4.566,3.706,5.038,4.076a16.684,16.684,0,0,1,2.886-2.471.062.062,0,1,1,.066.105,16.686,16.686,0,0,0-2.9,2.491.061.061,0,0,1-.084.008c-.179-.14-4.269-3.339-5.037-4.065a3.822,3.822,0,0,1-2.386,1.607,20.8,20.8,0,0,0,2.841,4.343,8.207,8.207,0,0,0,2.506,1.832,5.655,5.655,0,0,0,5.924-.62,21.347,21.347,0,0,0,2.67-3.076.061.061,0,0,1,.086-.014.062.062,0,0,1,.014.087,20.907,20.907,0,0,1-2.7,3.1,5.971,5.971,0,0,1-3.509,1.205",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M90.128,78.468a21.265,21.265,0,0,1-2.684,3.09c-4.626,3.29-8.509-1.219-8.509-1.219a21.324,21.324,0,0,1-2.887-4.427,3.7,3.7,0,0,0,2.461-1.667c.587.6,5.09,4.117,5.09,4.117a16.6,16.6,0,0,1,2.912-2.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M83.971,82.813a7.539,7.539,0,0,1-5.084-2.434,21.49,21.49,0,0,1-2.9-4.441.062.062,0,0,1,0-.053.06.06,0,0,1,.042-.034,3.679,3.679,0,0,0,2.42-1.634.062.062,0,0,1,.046-.034.061.061,0,0,1,.054.018c.546.554,4.566,3.706,5.038,4.076a16.684,16.684,0,0,1,2.886-2.471.062.062,0,1,1,.066.105,16.686,16.686,0,0,0-2.9,2.491.061.061,0,0,1-.084.008c-.179-.14-4.269-3.339-5.037-4.065a3.822,3.822,0,0,1-2.386,1.607,20.8,20.8,0,0,0,2.841,4.343,8.207,8.207,0,0,0,2.506,1.832,5.655,5.655,0,0,0,5.924-.62,21.347,21.347,0,0,0,2.67-3.076.061.061,0,0,1,.086-.014.062.062,0,0,1,.014.087,20.907,20.907,0,0,1-2.7,3.1,5.971,5.971,0,0,1-3.509,1.205",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M76.321,76.362a.044.044,0,0,1-.043-.038.042.042,0,0,1,.037-.049,4.948,4.948,0,0,0,2.538-1.651.044.044,0,0,1,.065.06,4.928,4.928,0,0,1-2.591,1.678h-.006",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M66.5,86.827l-7.147,1.086a2.015,2.015,0,0,1-2.3-1.689L56.5,82.55a2.017,2.017,0,0,1,1.69-2.3l7.148-1.086a2.015,2.015,0,0,1,2.295,1.69l.559,3.673a2.016,2.016,0,0,1-1.69,2.3",
    fill: "#4c5bdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M58,88.172a.829.829,0,0,1-.819-.7l-.933-6.141a.831.831,0,0,1,.695-.945L66.56,78.92a.829.829,0,0,1,.944.695l.934,6.142a.829.829,0,0,1-.7.944l-9.616,1.462a.89.89,0,0,1-.126.009m8.685-9.138a.785.785,0,0,0-.108.008L56.963,80.5a.706.706,0,0,0-.592.8l.934,6.142a.7.7,0,0,0,.8.591l9.616-1.461a.708.708,0,0,0,.592-.8l-.934-6.141a.7.7,0,0,0-.7-.6",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M62.319,84.6a.879.879,0,0,1-.495-.152l-5.3-3.614a.062.062,0,0,1,.069-.1l5.3,3.614a.762.762,0,0,0,1.02-.153L66.986,79.1a.063.063,0,0,1,.087-.009.062.062,0,0,1,.01.087L63.011,84.27a.885.885,0,0,1-.692.33",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 4.022,
    y2: 3.447,
    transform: "translate(64.114 82.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M68.136,86.454a.06.06,0,0,1-.04-.015l-4.022-3.446a.063.063,0,0,1-.007-.088.062.062,0,0,1,.087-.007l4.022,3.447a.062.062,0,0,1,.007.087.06.06,0,0,1-.047.022",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x1: 2.816,
    y2: 4.486,
    transform: "translate(57.696 83.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M57.7,88.041a.066.066,0,0,1-.033-.009.063.063,0,0,1-.02-.086L60.46,83.46a.062.062,0,0,1,.1.066l-2.816,4.486a.062.062,0,0,1-.053.029",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M54.576,85.48c-.695-.008-1.49.708-3.044,1.424a16.87,16.87,0,0,0,.741,1.695,9.917,9.917,0,0,0,3.405-1Z",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M52.273,88.664a.064.064,0,0,1-.058-.036,16.861,16.861,0,0,1-.744-1.7.067.067,0,0,1,.034-.083c.609-.28,1.092-.556,1.518-.8a3.539,3.539,0,0,1,1.542-.631h.012a.069.069,0,0,1,.058.036l1.1,2.117a.065.065,0,0,1-.027.088,9.949,9.949,0,0,1-3.428,1.009h-.008m-.658-1.726a16.954,16.954,0,0,0,.7,1.59,9.867,9.867,0,0,0,3.279-.958l-1.053-2.024a3.631,3.631,0,0,0-1.449.613c-.4.226-.883.5-1.473.779",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M63.2,87.008c-.144-.209-.94.5-.94.5s1.071-.979.862-1.149c-.247-.2-1.123.7-1.123.7s1.11-1.213.875-1.292c-.162-.054-.71.391-1.038.675-.144.132-.254.226-.254.226s.1-.1.254-.226c.328-.3.83-.811.594-.884-.339-.1-1.5,1.084-1.5,1.084s.34-1.253-.13-.966a2.085,2.085,0,0,0-.7.988,25.6,25.6,0,0,0-4.288,1.182l-.13-.25a9.9,9.9,0,0,1-3.405,1c.579,1.143,1.339,2.272,2.113,2.531,2.195.733,6.49-2.5,6.49-2.5A3.6,3.6,0,0,0,63.2,87.008",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M55.122,91.3a2.352,2.352,0,0,1-.755-.113c-.847-.283-1.636-1.549-2.149-2.561a.061.061,0,0,1,0-.057.059.059,0,0,1,.047-.032,9.813,9.813,0,0,0,3.383-1,.062.062,0,0,1,.048,0,.06.06,0,0,1,.036.03l.106.2A26.3,26.3,0,0,1,60.05,86.61a2.066,2.066,0,0,1,.716-.986c.1-.062.184-.069.248-.021.153.115.09.548.027.84.355-.347,1.106-1.035,1.406-.943a.139.139,0,0,1,.1.1c.008.032.023.1-.1.283.323-.218.409-.189.45-.176a.1.1,0,0,1,.07.076c.031.116-.154.4-.372.676.223-.155.446-.254.569-.154a.138.138,0,0,1,.05.106,1.226,1.226,0,0,1-.357.581.556.556,0,0,1,.287-.085.153.153,0,0,1,.11.064.133.133,0,0,1,0,.123A4.006,4.006,0,0,1,60.9,88.684a20.927,20.927,0,0,1-2.418,1.523A7.687,7.687,0,0,1,55.122,91.3m-2.753-2.651c.5.977,1.252,2.158,2.037,2.421,2.139.714,6.39-2.461,6.433-2.493a.068.068,0,0,1,.026-.012,3.875,3.875,0,0,0,2.275-1.529l-.015,0c-.155-.02-.587.308-.824.518a.062.062,0,0,1-.088-.005.063.063,0,0,1,0-.087c.338-.309.873-.866.868-1.041,0-.01,0-.012,0-.013-.126-.1-.637.284-1.039.7a.061.061,0,0,1-.087,0,.062.062,0,0,1,0-.087,4.745,4.745,0,0,0,.891-1.192c-.039,0-.243.036-.969.664-.143.132-.254.226-.254.226a.062.062,0,0,1-.082-.093s.1-.1.255-.227c.649-.6.637-.751.633-.766s0-.007-.016-.011c-.219-.067-1,.618-1.438,1.067a.061.061,0,0,1-.075.01.06.06,0,0,1-.029-.07c.1-.39.162-.855.07-.924-.026-.019-.085.013-.109.028a2.045,2.045,0,0,0-.675.954.061.061,0,0,1-.049.042,25.864,25.864,0,0,0-4.277,1.18.062.062,0,0,1-.075-.03l-.1-.195a9.93,9.93,0,0,1-3.283.968m10.779-1.606h0",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M61.834,86.443c-.15.13-.254.226-.254.226s.11-.093.254-.226",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M61.581,86.73a.059.059,0,0,1-.046-.021.061.061,0,0,1,0-.086s.1-.1.255-.227a.064.064,0,0,1,.088.006.062.062,0,0,1-.005.087c-.145.133-.256.226-.256.226a.053.053,0,0,1-.039.015",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M54.3,81.35a3.782,3.782,0,0,0-1.832,1.012c-1.234,1.371-1.409,5.207-1.409,5.207s3.014.744,4.815-.431a13.534,13.534,0,0,0-.548-2.78",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M53.139,87.863c-.12,0-.236,0-.347-.007a9.786,9.786,0,0,1-1.745-.227A.062.062,0,0,1,51,87.566c.007-.157.19-3.873,1.425-5.246a3.807,3.807,0,0,1,1.866-1.031.062.062,0,0,1,.025.122,3.738,3.738,0,0,0-1.8.992c-1.129,1.254-1.364,4.657-1.391,5.117.4.088,3.051.624,4.685-.414a13.47,13.47,0,0,0-.541-2.728.062.062,0,0,1,.117-.039,13.725,13.725,0,0,1,.551,2.794.061.061,0,0,1-.028.057,5.188,5.188,0,0,1-2.772.673",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M56.172,82.19c-2.031,0-2.343-.684-2.356-.715a.033.033,0,0,1,.018-.043.034.034,0,0,1,.043.018.9.9,0,0,0,.437.357,4.581,4.581,0,0,0,2.122.314.036.036,0,0,1,.034.032.032.032,0,0,1-.032.033c-.092,0-.181,0-.266,0",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M68.7,82.607a.468.468,0,0,0-.542-.387,1.714,1.714,0,0,0-.6.157c-.49.244.741.237.741.237s-1.195.2-1.285.539.963.026.963.026-.987.341-1.044.58,1.156-.019,1.156-.019-.859.153-.82.468c.034.266,1.059-.012,1.059-.012s-.684.168-.582.4c0,0,.1.283.92-.265.44-.294.2-1.208.033-1.724",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M67.9,84.732a.322.322,0,0,1-.1-.015.181.181,0,0,1-.117-.1.176.176,0,0,1,.006-.15.316.316,0,0,1,.083-.1.85.85,0,0,1-.5-.039.155.155,0,0,1-.073-.114c-.016-.124.071-.225.195-.3a.777.777,0,0,1-.5-.055.116.116,0,0,1-.03-.111c.03-.126.244-.262.477-.376a.494.494,0,0,1-.356-.065.16.16,0,0,1-.039-.167c.059-.224.491-.384.85-.479-.261-.026-.4-.078-.421-.157-.022-.1.1-.156.148-.18a1.764,1.764,0,0,1,.62-.164.529.529,0,0,1,.607.431c.113.358.459,1.449-.057,1.794a1.673,1.673,0,0,1-.795.349m.389-.463c-.181.05-.441.152-.491.254a.053.053,0,0,0,0,.049.077.077,0,0,0,.049.03c.081.02.291.006.781-.322.291-.195.293-.751.008-1.654-.085-.267-.223-.368-.478-.344a1.613,1.613,0,0,0-.576.152.39.39,0,0,0-.071.042,2.787,2.787,0,0,0,.783.077.062.062,0,0,1,.01.123c-.446.074-1.176.273-1.234.494-.009.032,0,.042.005.046.082.08.521.012.88-.1a.063.063,0,0,1,.077.041.062.062,0,0,1-.039.077c-.4.137-.97.394-1,.536a2.349,2.349,0,0,0,.976-.072c.053-.013.092-.02.109-.023a.062.062,0,0,1,.024.122l-.1.021c-.276.064-.688.208-.666.379a.036.036,0,0,0,.019.026,1.889,1.889,0,0,0,.914-.078l.048-.013a.062.062,0,0,1,.075.045.061.061,0,0,1-.044.075l-.048.013",
    fill: "#222221"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeyondMail);
export default __webpack_public_path__ + "static/media/beyond_Mail.ed5686964d3fbfdfd854d1d5469960e2.svg";
export { ForwardRef as ReactComponent };